import { connect } from 'react-redux';
import TinyRevenueRules from '../views/tiny/TinyRevenueRules';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const TinyRevenueRulesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyRevenueRules);

export default TinyRevenueRulesContainer;
